/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["roles{display:block}roles .spacing-container{padding:25px;display:flex}roles .new-role{border-bottom:1px solid #e0e0e0;margin-bottom:10px;padding-bottom:10px}roles data-table{flex:1 1 auto}"];
export { styles as styles };
